export default __webpack_public_path__ + "static/media/iconSuccess16.7463ad41.svg";